import styled from 'react-emotion';
import { styles } from './styles';
import { getColorByType, ColorTypes } from '../../variables/colors';

interface Props {
  // type?: ColorTypes;
  color?: ColorTypes;
  tall?: boolean;
  wide?: boolean;
  transparent?: boolean;
  rounded?: boolean;
  className?: string;
}

export const Button = styled<'button'>('button')<Props>(({ color, tall, wide, rounded, transparent }) => {
  return styles.button(getColorByType(color), (color = 'action'), tall, wide, transparent, rounded);
});

export const LinkButton = Button.withComponent('a');
